export default __webpack_public_path__ + "static/media/title.efc47f82.png";